export enum PhotoOwnerType {
  Territory = 'Territory',
  MunicipalitySchools = 'MunicipalitySchools',
  UserPhoto = 'UserPhoto',
  LenderLogo = 'LenderLogo',
  NeighborhoodPlat = 'NeighborhoodPlat',
  NeighborhoodLogo = 'NeighborhoodLogo',
  NeighborhoodAction = 'NeighborhoodAction',
  AmenityClubhouse = 'AmenityClubhouse',
  AmenityCommonArea = 'AmenityCommonArea',
  AmenityFitnessCenter = 'AmenityFitnessCenter',
  AmenityLakes = 'AmenityLakes',
  AmenityPlayground = 'AmenityPlayground',
  AmenityPool = 'AmenityPool',
  AmenityTennisFacility = 'AmenityTennisFacility',
  AmenityWalkingTrail = 'AmenityWalkingTrail',
  PlaceOrder = 'PlaceOrder',
  Punchlist = 'Punchlist'
}
